// Admin-Guard: ohne Anmeldung → „Bitte anmelden", ohne isAdmin → „Kein Zugriff" (ohne Admin-API-Aufrufe).
import type { ReactNode } from 'react';
import { useAuthStore } from '../../../store/auth';
import { AdminForbidden, AdminLoginRequired } from './parts';

export function AdminGuard(props: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (!user) return <AdminLoginRequired />;
  if (!user.isAdmin) return <AdminForbidden />;
  return <>{props.children}</>;
}
